// typings

import { create } from "zustand";

import { ISearchShipmentState } from "@/store-zustand/search-shipment/index";

// criação da store com Zustand (Remessas)
export const useStoreZustandSearchShipment = create<ISearchShipmentState>((set) => ({
  // estados
  isLoading: false,
  isModal: false,
  isLoadingPage: false,
  searchShipment: null,
  itemsPerPage: 10,
  currentPage: 1,
  totalItemsPage: 0,
  searchItem: "",
  paginations: [1],
  lastPage: 1,
  remessa: null,

  // ações
  setIsLoading: (isLoading) => set({ isLoading }),
  setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
  setSearchShipment: (searchShipment) => set({ searchShipment }),
  setSearchItem: (searchItem) => set({ searchItem }),
  setIsLoadingPage: (isLoadingPage) => set({ isLoadingPage }),
  setIsModal: (isModal) => set({ isModal }),
  setPaginations: (paginations) => set({ paginations }),
  setLastPage: (lastPage) => set({ lastPage }),
  setRemessa: (remessa) => set({ remessa }),
}));
